/* =====================================================================
   Wise — Espace compte « whac- » (équipe Comptes clients)
   Chargé en defer (après wh-core.js s'il est présent) sur /pages/compte
   et sur les gabarits customers/*. wise.js, exécuté avant en fin de body
   et non modifié, reste le moteur : onglets [data-acct-tab], favoris,
   vus récemment, code promo, roue, parrainage (copie, saisie), coordonnées,
   bouton œil, jauge de mot de passe, adresses.
   Ce fichier ne se branche sur AUCUN de ces crochets pour refaire leur
   travail ; il complète :
   - onglets : rôles ARIA tenus à jour (observation des classes posées par
     wise.js), flèches du clavier (elles déclenchent le clic de wise.js),
     ancres changées sans recharger (lien « Favoris » du menu), ancres de
     retour de formulaire (#coordonnees, #ref-claim), adresse de la page
     mise à jour (#commandes, #favoris, #avantages, #parametres) ;
   - roue : pastille « tour disponible » sur l'onglet, annonce du lot aux
     lecteurs d'écran, focus et défilement vers le résultat ;
   - parrainage : bouton Partager au texte réglable (data-whac-share) ;
   - formulaires de compte classiques : contrôle en français avant envoi,
     alerte Majuscules, pas de double envoi ;
   - visiteur : favoris masqués s'ils sont vides (sauf ancre #favoris) ;
   - popup « Créez votre compte » de wise.js refermée sur ces pages.
   ES2017 au plus, sans dépendance, idempotent.
   ===================================================================== */
(function () {
  'use strict';

  if (window.WHAC) return;

  var doc = document;
  var hasMO = typeof window.MutationObserver === 'function';
  var mqReduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var WISE_HASHES = { '#commandes': 1, '#favoris': 1, '#avantages': 1, '#parametres': 1 };
  var HASH_TO_KEY = {
    '#commandes': 'orders',
    '#favoris': 'wishlist',
    '#avantages': 'rewards',
    '#parrainage': 'rewards',
    '#ref-claim': 'rewards',
    '#parametres': 'settings',
    '#profil': 'settings',
    '#coordonnees': 'settings'
  };
  var KEY_TO_HASH = { orders: '#commandes', wishlist: '#favoris', rewards: '#avantages', settings: '#parametres' };
  var ROOTS = '[data-whac-dash], [data-whac-portal], [data-whac-auth], [data-whac-order], [data-whac-addresses]';

  /* ---------- Utilitaires ---------- */
  function report(err) {
    if (window.console && typeof window.console.error === 'function') window.console.error('[whac]', err);
  }

  function safe(fn, a, b) {
    try {
      return fn(a, b);
    } catch (err) {
      report(err);
      return undefined;
    }
  }

  function all(selector, ctx) {
    var base = ctx || doc;
    if (!base || typeof base.querySelectorAll !== 'function') return [];
    return Array.prototype.slice.call(base.querySelectorAll(selector));
  }

  function one(selector, ctx) {
    var base = ctx || doc;
    return base && typeof base.querySelector === 'function' ? base.querySelector(selector) : null;
  }

  function matches(el, selector) {
    if (!el || el.nodeType !== 1) return false;
    var fn = el.matches || el.webkitMatchesSelector || el.msMatchesSelector;
    return !!fn && fn.call(el, selector);
  }

  function closest(node, selector) {
    var el = node && node.nodeType === 1 ? node : node && node.parentNode;
    while (el && el.nodeType === 1) {
      if (matches(el, selector)) return el;
      el = el.parentNode;
    }
    return null;
  }

  /* Éléments du scope correspondant au sélecteur, scope compris. */
  function within(scope, selector) {
    var list = all(selector, scope);
    if (matches(scope, selector)) list.unshift(scope);
    return list;
  }

  function reduced() {
    if (window.WH && typeof window.WH.reduced === 'boolean') return window.WH.reduced;
    return !!(mqReduce && mqReduce.matches);
  }

  function lsGet(key) {
    try { return window.localStorage.getItem(key); } catch (e) { return null; }
  }

  function lsSet(key, value) {
    try { window.localStorage.setItem(key, value); } catch (e) { /* stockage indisponible */ }
  }

  function readList(key) {
    try {
      var list = JSON.parse(lsGet(key) || '[]');
      return Object.prototype.toString.call(list) === '[object Array]' ? list : [];
    } catch (e) {
      return [];
    }
  }

  function textOf(id) {
    var el = doc.getElementById(id);
    return el ? String(el.textContent || '').replace(/^\s+|\s+$/g, '') : '';
  }

  /* Région « live » du layout (la même que wise.js). */
  function announce(message) {
    var region = doc.getElementById('live-region');
    if (!region || !message) return;
    region.textContent = '';
    window.setTimeout(function () { region.textContent = message; }, 90);
  }

  function focusEl(el) {
    if (!el || typeof el.focus !== 'function') return;
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  }

  /* Hauteur du header fixe du thème (+ marge). */
  function headerOffset() {
    var raw = '';
    try { raw = window.getComputedStyle(doc.documentElement).getPropertyValue('--v23-head-h'); } catch (e) { raw = ''; }
    var h = parseFloat(raw);
    return (isNaN(h) ? 72 : h) + 16;
  }

  function scrollToEl(el) {
    if (!el || typeof el.getBoundingClientRect !== 'function') return;
    var top = el.getBoundingClientRect().top + (window.pageYOffset || doc.documentElement.scrollTop || 0) - headerOffset();
    try {
      window.scrollTo({ top: Math.max(0, top), behavior: reduced() ? 'auto' : 'smooth' });
    } catch (e) {
      window.scrollTo(0, Math.max(0, top));
    }
  }

  /* Ramène l'élément à l'écran seulement s'il en sort (barre d'onglets mobile comprise). */
  function revealEl(el) {
    if (!el || typeof el.getBoundingClientRect !== 'function') return;
    var rect = el.getBoundingClientRect();
    var view = window.innerHeight || doc.documentElement.clientHeight;
    if (rect.top >= headerOffset() && rect.bottom <= view - 72) return;
    try {
      el.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'center' });
    } catch (e) {
      el.scrollIntoView();
    }
  }

  function copyText(text, done) {
    var clip = navigator.clipboard;
    if (clip && typeof clip.writeText === 'function' && window.isSecureContext !== false) {
      clip.writeText(text).then(function () { done(true); }, function () { done(legacyCopy(text)); });
    } else {
      done(legacyCopy(text));
    }
  }

  function legacyCopy(text) {
    var area = doc.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', '');
    area.style.position = 'fixed';
    area.style.top = '0';
    area.style.left = '0';
    area.style.opacity = '0';
    area.style.fontSize = '16px';
    doc.body.appendChild(area);
    area.select();
    var ok = false;
    try { ok = doc.execCommand('copy'); } catch (e) { ok = false; }
    doc.body.removeChild(area);
    return ok;
  }

  /* Nettoyage dans l'éditeur de thème (section retirée ou rechargée). */
  var cleanups = [];

  function onCleanup(root, fn) {
    cleanups.push({ root: root, fn: fn });
  }

  function cleanupIn(scope) {
    var keep = [];
    for (var i = 0; i < cleanups.length; i++) {
      var item = cleanups[i];
      if (scope === item.root || (scope.contains && scope.contains(item.root))) safe(item.fn);
      else keep.push(item);
    }
    cleanups = keep;
  }

  /* ---------- Tableau de bord ---------- */
  function initDash(root, fresh) {
    if (root.__whacDash) return;
    root.__whacDash = true;

    var list = one('[data-whac-tablist]', root);
    var tabs = list ? all('[role="tab"][data-acct-tab]', list) : [];
    if (!tabs.length) return;
    var mqDesk = window.matchMedia ? window.matchMedia('(min-width: 1024px)') : null;
    var observers = [];

    function keyOf(el) { return el ? el.getAttribute('data-acct-tab') : ''; }

    function tabFor(key) {
      for (var i = 0; i < tabs.length; i++) {
        if (keyOf(tabs[i]) === key) return tabs[i];
      }
      return null;
    }

    function activeTab() {
      for (var i = 0; i < tabs.length; i++) {
        if (tabs[i].classList.contains('is-active')) return tabs[i];
      }
      return null;
    }

    function sync() {
      tabs.forEach(function (tab) {
        var on = tab.classList.contains('is-active');
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.setAttribute('tabindex', on ? '0' : '-1');
      });
    }

    function orient() {
      list.setAttribute('aria-orientation', mqDesk && mqDesk.matches ? 'vertical' : 'horizontal');
    }

    /* Onglet actif visible dans la rangée défilante (mobile). */
    function keepVisible(tab) {
      if (mqDesk && mqDesk.matches) return;
      if (list.scrollWidth <= list.clientWidth + 1) return;
      var lr = list.getBoundingClientRect();
      var tr = tab.getBoundingClientRect();
      if (tr.left >= lr.left && tr.right <= lr.right) return;
      var left = Math.max(0, list.scrollLeft + (tr.left - lr.left) - (lr.width - tr.width) / 2);
      try {
        list.scrollTo({ left: left, behavior: reduced() ? 'auto' : 'smooth' });
      } catch (e) {
        list.scrollLeft = left;
      }
    }

    /* Le clic est traité par wise.js (ou par le repli ci-dessous dans l'éditeur). */
    function go(key) {
      var tab = tabFor(key);
      if (tab && !tab.classList.contains('is-active')) tab.click();
      return tab;
    }

    /* Section rechargée dans l'éditeur : wise.js n'a pas lié ces nouveaux éléments. */
    if (fresh) {
      root.addEventListener('click', function (e) {
        var trigger = closest(e.target, '[data-acct-tab]');
        if (!trigger || !root.contains(trigger)) return;
        var key = keyOf(trigger);
        all('[data-acct-tab]', root).forEach(function (el) { el.classList.toggle('is-active', keyOf(el) === key); });
        all('[data-acct-panel]', root).forEach(function (el) { el.classList.toggle('is-active', el.getAttribute('data-acct-panel') === key); });
      });
    }

    var current = activeTab();

    function onChange() {
      sync();
      var tab = activeTab();
      if (!tab || tab === current) return;
      current = tab;
      keepVisible(tab);
      var hash = KEY_TO_HASH[keyOf(tab)];
      if (hash && location.hash !== hash && window.history && typeof window.history.replaceState === 'function') {
        try { window.history.replaceState(window.history.state, '', location.pathname + location.search + hash); } catch (e) { /* adresse inchangée */ }
      }
    }

    sync();
    orient();
    if (current) keepVisible(current);

    if (hasMO) {
      var tabObserver = new window.MutationObserver(onChange);
      tabs.forEach(function (tab) { tabObserver.observe(tab, { attributes: true, attributeFilter: ['class'] }); });
      observers.push(tabObserver);
    }

    if (mqDesk) {
      if (typeof mqDesk.addEventListener === 'function') mqDesk.addEventListener('change', orient);
      else if (typeof mqDesk.addListener === 'function') mqDesk.addListener(orient);
    }

    /* Clavier : flèches, Début, Fin (le clic garde le comportement de wise.js). */
    list.addEventListener('keydown', function (e) {
      var i = tabs.indexOf(e.target);
      if (i < 0) return;
      var end = tabs.length - 1;
      var key = e.key;
      var to = -1;
      if (key === 'ArrowRight' || key === 'ArrowDown' || key === 'Right' || key === 'Down') to = i === end ? 0 : i + 1;
      else if (key === 'ArrowLeft' || key === 'ArrowUp' || key === 'Left' || key === 'Up') to = i === 0 ? end : i - 1;
      else if (key === 'Home') to = 0;
      else if (key === 'End') to = end;
      if (to < 0) return;
      e.preventDefault();
      focusEl(tabs[to]);
      tabs[to].click();
    });

    /* Raccourcis hors onglets (ex. « Mon tour de roue ») : wise.js change d'onglet, on remonte vers les onglets. */
    root.addEventListener('click', function (e) {
      var trigger = closest(e.target, '[data-acct-tab]');
      if (!trigger || trigger.getAttribute('role') === 'tab' || !root.contains(trigger)) return;
      window.setTimeout(function () {
        scrollToEl(list);
        focusEl(tabFor(keyOf(trigger)));
      }, 0);
    });

    /* Ancres : lien « Favoris » du menu sur cette même page, retours de formulaire. */
    function fromHash(scroll) {
      var key = HASH_TO_KEY[location.hash];
      if (!key) return;
      var tab = go(key);
      if (!tab || !scroll) return;
      var target = location.hash.length > 1 ? doc.getElementById(location.hash.slice(1)) : null;
      window.setTimeout(function () { scrollToEl(target && root.contains(target) ? target : list); }, 60);
    }

    var onHash = function () { fromHash(true); };
    window.addEventListener('hashchange', onHash);
    if (location.hash && !WISE_HASHES[location.hash]) fromHash(true);

    /* Retour d'un formulaire de contact : Shopify marque TOUS les formulaires de la page
       comme envoyés ; on ne garde que la confirmation du formulaire visé par l'ancre. */
    var formHash = location.hash === '#ref-claim' || location.hash === '#coordonnees' ? location.hash.slice(1) : '';
    if (formHash) {
      all('[data-whac-for]', root).forEach(function (alertEl) {
        if (alertEl.getAttribute('data-whac-for') !== formHash) alertEl.hidden = true;
      });
      var coordPanel = one('[data-coord-panel]', root);
      var coordToggle = one('[data-coord-toggle]', root);
      if (coordPanel && coordToggle) {
        /* wise.js ouvre le volet sur une confirmation : on le referme si elle concernait l'autre formulaire,
           et on l'ouvre sur une erreur des coordonnées (wise.js ne le fait pas). */
        var coordShown = one('[data-whac-for="coordonnees"]:not([hidden])', coordPanel);
        if (!coordShown && !coordPanel.hidden) coordToggle.click();
        else if (coordShown && coordPanel.hidden && formHash === 'coordonnees') coordToggle.click();
      }
    }

    /* Code promo (boutons de wise.js) : Entrée = Enregistrer, annonce et focus.
       Écoute par délégation sur la carte : aucun écouteur sur les crochets eux-mêmes. */
    var promoCard = one('.whac-promo', root);
    var promoInput = one('#acct-promo-input', root);
    var promoSaved = one('[data-promo-saved]', root);
    var promoRemove = one('[data-promo-remove]', root);
    var promoByUser = false;
    if (promoCard) {
      promoCard.addEventListener('keydown', function (e) {
        if (e.target !== promoInput || (e.key !== 'Enter' && e.keyCode !== 13)) return;
        var save = one('[data-promo-save]', promoCard);
        if (!save) return;
        e.preventDefault();
        save.click();
      });
      promoCard.addEventListener('click', function (e) {
        if (closest(e.target, '[data-promo-save], [data-promo-remove]')) promoByUser = true;
      });
    }
    if (hasMO && promoSaved) {
      var promoObserver = new window.MutationObserver(function () {
        if (!promoByUser) return;
        promoByUser = false;
        if (!promoSaved.hidden) {
          var codeEl = one('[data-promo-code]', promoSaved);
          var code = codeEl ? String(codeEl.textContent || '').replace(/^\s+|\s+$/g, '') : '';
          announce('Code ' + code + ' enregistré : il sera pré-rempli dans votre panier.');
          focusEl(promoRemove);
        } else {
          announce('Code retiré.');
          focusEl(promoInput);
        }
      });
      promoObserver.observe(promoSaved, { attributes: true, attributeFilter: ['hidden'] });
      observers.push(promoObserver);
    }

    /* Roue (moteur wise.js) : pastille, annonce du lot, focus. */
    var spin = one('#wheel-spin', root);
    var result = one('#wheel-result', root);
    var dot = one('[data-whac-spin-dot]', root);
    if (spin && dot) {
      var updateDot = function () { dot.hidden = !!spin.disabled; };
      updateDot();
      if (hasMO) {
        var dotObserver = new window.MutationObserver(updateDot);
        dotObserver.observe(spin, { attributes: true, attributeFilter: ['disabled'] });
        observers.push(dotObserver);
      }
    }
    if (spin && result && hasMO) {
      var prizes = [];
      try {
        var raw = one('#wheel-data', root);
        prizes = raw ? JSON.parse(raw.textContent || '[]') : [];
      } catch (e) {
        prizes = [];
      }
      var armed = !result.classList.contains('is-on');
      var resultObserver = new window.MutationObserver(function () {
        if (!result.classList.contains('is-on')) {
          armed = true;
          return;
        }
        if (!armed) return;
        armed = false;
        var title = textOf('wheel-result-title');
        var desc = textOf('wheel-result-text');
        var codeEl = doc.getElementById('wheel-result-code');
        var code = codeEl && !codeEl.hidden ? String(codeEl.getAttribute('data-code') || codeEl.textContent || '').replace(/^\s+|\s+$/g, '') : '';
        var prize = null;
        for (var i = 0; i < prizes.length; i++) {
          if (prizes[i] && prizes[i].label === title) {
            prize = prizes[i];
            break;
          }
        }
        if (code) {
          announce('Gagné : ' + title + '. Votre code ' + code + ' est enregistré et pré-rempli dans votre panier.');
        } else if (!(prize && prize.lose)) {
          announce(title + (desc ? '. ' + desc : ''));
        }
        /* Perdu : wise.js annonce déjà « Pas de lot cette fois ». */
        var active = doc.activeElement;
        if (spin.disabled || !active || active === doc.body) focusEl(result);
        window.setTimeout(function () { revealEl(result); }, reduced() ? 0 : 320);
      });
      resultObserver.observe(result, { attributes: true, attributeFilter: ['class'] });
      observers.push(resultObserver);
    }

    onCleanup(root, function () {
      observers.forEach(function (o) { o.disconnect(); });
      window.removeEventListener('hashchange', onHash);
      if (mqDesk) {
        if (typeof mqDesk.removeEventListener === 'function') mqDesk.removeEventListener('change', orient);
        else if (typeof mqDesk.removeListener === 'function') mqDesk.removeListener(orient);
      }
      root.__whacDash = false;
    });
  }

  /* ---------- Accueil visiteur : favoris de l'appareil ---------- */
  function initPortal(root) {
    if (root.__whacPortal) return;
    root.__whacPortal = true;
    var favs = one('[data-whac-favs]', root);
    if (!favs) return;

    function hasContent() {
      return readList('wise_wishlist').length > 0 || readList('wise_recent_products').length > 0;
    }

    if (location.hash !== '#favoris' && !hasContent()) favs.hidden = true;

    var onHash = function () {
      if (location.hash !== '#favoris') return;
      favs.hidden = false;
      window.setTimeout(function () { scrollToEl(favs); }, 30);
    };
    window.addEventListener('hashchange', onHash);
    onCleanup(root, function () {
      window.removeEventListener('hashchange', onHash);
      root.__whacPortal = false;
    });
  }

  /* ---------- Parrainage : partage (texte rendu par Liquid, montants réglables) ---------- */
  function initShare(scope) {
    all('[data-whac-share]', scope).forEach(function (btn) {
      if (btn.__whacShare) return;
      btn.__whacShare = true;
      btn.addEventListener('click', function () {
        var text = btn.getAttribute('data-text') || '';
        var url = btn.getAttribute('data-url') || (location.protocol + '//' + location.host);
        var card = closest(btn, '.whac-ref') || doc;
        var feedback = one('[data-ref-feedback]', card);
        function say(message) {
          if (feedback) {
            feedback.textContent = message;
            feedback.hidden = false;
          }
          announce(message);
        }
        if (navigator.share) {
          navigator.share({ title: doc.title, text: text, url: url }).catch(function () { /* partage annulé */ });
          return;
        }
        copyText(text + ' ' + url, function (ok) {
          say(ok ? 'Message de parrainage copié : collez-le où vous voulez.' : 'Copie impossible : recopiez votre code à la main.');
        });
      });
    });
  }

  /* ---------- Formulaires de compte classiques : contrôle avant envoi ---------- */
  function errorFor(input, form) {
    var kind = input.getAttribute('data-whac-check');
    var value = String(input.value || '');
    if (kind === 'email') {
      value = value.replace(/^\s+|\s+$/g, '');
      if (!value) return 'Indiquez votre adresse e-mail.';
      if (!EMAIL_RE.test(value)) return 'Cette adresse e-mail semble incomplète (exemple : prenom@exemple.fr).';
      return '';
    }
    if (kind === 'password') {
      if (!value) return 'Indiquez votre mot de passe.';
      var min = parseInt(input.getAttribute('data-min'), 10) || 0;
      if (min && value.length < min) return 'Choisissez au moins ' + min + ' caractères.';
      return '';
    }
    if (kind === 'confirm') {
      if (!value) return 'Confirmez le mot de passe.';
      var other = doc.getElementById(input.getAttribute('data-match') || '');
      if (other && other.value !== value) return 'Les deux mots de passe ne sont pas identiques.';
      return '';
    }
    if (kind === 'required') return value.replace(/\s+/g, '') ? '' : 'Ce champ est obligatoire.';
    return '';
  }

  function setError(input, message) {
    var box = input.id ? doc.getElementById(input.id + '-err') : null;
    if (message) input.setAttribute('aria-invalid', 'true');
    else input.removeAttribute('aria-invalid');
    if (box) {
      box.textContent = message;
      box.hidden = !message;
    }
  }

  function initForms(scope) {
    all('form', scope).forEach(function (form) {
      if (form.__whacForm || !one('[data-whac-check]', form)) return;
      form.__whacForm = true;
      var fields = all('[data-whac-check]', form);

      fields.forEach(function (input) {
        input.addEventListener('blur', function () {
          if (input.value) setError(input, errorFor(input, form));
        });
        input.addEventListener('input', function () {
          if (input.getAttribute('aria-invalid') === 'true') setError(input, errorFor(input, form));
        });
      });

      /* Bouton d'envoi utilisé (repli si event.submitter manque). */
      form.addEventListener('click', function (e) {
        var btn = closest(e.target, 'button[type="submit"], input[type="submit"]');
        if (btn && form.contains(btn)) form.__whacSubmitter = btn;
      });

      form.addEventListener('submit', function (e) {
        var submitter = e.submitter || form.__whacSubmitter || null;
        form.__whacSubmitter = null;
        if (submitter && submitter.name === 'decline') return;
        if (form.__whacSent) {
          e.preventDefault();
          return;
        }
        var first = null;
        fields.forEach(function (input) {
          var message = errorFor(input, form);
          setError(input, message);
          if (message && !first) first = input;
        });
        if (first) {
          e.preventDefault();
          first.focus();
          return;
        }
        form.__whacSent = true;
        var btn = submitter && !submitter.name ? submitter : one('button[type="submit"]:not([name])', form);
        if (btn) btn.setAttribute('aria-busy', 'true');
        /* Filet : si la page ne change pas (hors ligne, retour arrière), le formulaire redevient utilisable. */
        window.setTimeout(function () {
          form.__whacSent = false;
          if (btn) btn.removeAttribute('aria-busy');
        }, 8000);
      });
    });
  }

  /* Alerte « Majuscules activées » sous les champs mot de passe.
     Le <p> est vide dans le Liquid : référencé par aria-describedby, il serait lu même masqué.
     Le texte n'est écrit que pendant que la touche est réellement activée. */
  var CAPS_TEXT = 'La touche Majuscules est activée.';

  function initCaps(scope) {
    all('input[type="password"]', scope).forEach(function (input) {
      if (input.__whacCaps || !input.id) return;
      var hint = doc.getElementById(input.id + '-caps');
      if (!hint) return;
      input.__whacCaps = true;
      var show = function (on) {
        if (on) {
          if (hint.textContent !== CAPS_TEXT) hint.textContent = CAPS_TEXT;
          hint.hidden = false;
        } else {
          hint.hidden = true;
          if (hint.textContent) hint.textContent = '';
        }
      };
      var update = function (e) {
        if (e && typeof e.getModifierState === 'function') show(e.getModifierState('CapsLock'));
      };
      show(false);
      input.addEventListener('keydown', update);
      input.addEventListener('keyup', update);
      input.addEventListener('blur', function () { show(false); });
    });
  }

  /* Connexion classique : wise.js masque le volet du lien cliqué (« Mot de passe oublié ? »,
     « Retour à la connexion »). Aucun écouteur sur ces crochets : on observe l'attribut hidden
     des volets et on place le focus dans le volet qui apparaît si le focus a été perdu. */
  function initAuthPanes(scope) {
    var login = one('#login-pane', scope) || (matches(scope, '#login-pane') ? scope : null);
    var recover = one('#recover-pane', scope) || (matches(scope, '#recover-pane') ? scope : null);
    if (!login || !recover || !hasMO || login.__whacPane) return;
    login.__whacPane = true;
    recover.__whacPane = true;

    /* Volet « nouveau mot de passe » rouvert avec un message d'envoi : le message d'abord. */
    function target(pane) {
      var msg = pane === recover ? one('.form-ok, .form-err', pane) : null;
      if (msg) {
        if (!msg.hasAttribute('tabindex')) msg.setAttribute('tabindex', '-1');
        return msg;
      }
      return one(pane === recover ? '#recover-email' : '#login-email', pane) ||
        one('input:not([type="hidden"])', pane);
    }

    function watch(pane, other) {
      var wasOpen = !pane.hidden;
      var observer = new window.MutationObserver(function () {
        var open = !pane.hidden;
        if (open && !wasOpen) {
          var active = doc.activeElement;
          if (!active || active === doc.body || other.contains(active)) focusEl(target(pane));
        }
        wasOpen = open;
      });
      observer.observe(pane, { attributes: true, attributeFilter: ['hidden'] });
      onCleanup(pane, function () {
        observer.disconnect();
        pane.__whacPane = false;
      });
    }

    watch(recover, login);
    watch(login, recover);
  }

  /* Volets ouverts par wise.js (adresses, coordonnées) : aria-expanded et focus sur le 1er champ. */
  function initDisclosures(scope) {
    all('[data-addr-toggle][aria-controls], [data-coord-toggle][aria-controls]', scope).forEach(function (btn) {
      if (btn.__whacDisclosure) return;
      var target = doc.getElementById(btn.getAttribute('aria-controls'));
      if (!target) return;
      btn.__whacDisclosure = true;
      var managesExpanded = btn.hasAttribute('data-addr-toggle');
      var wasOpen = !target.hidden;
      var update = function () {
        var open = !target.hidden;
        if (managesExpanded) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        var active = doc.activeElement;
        if (open && !wasOpen && active === btn) {
          var field = one('input:not([type="hidden"]):not([type="checkbox"]), select, textarea', target);
          if (field) focusEl(field);
        } else if (!open && wasOpen && (!active || active === doc.body || target.contains(active))) {
          /* « Annuler » est dans le volet que wise.js masque : le focus revient au bouton d'ouverture. */
          focusEl(btn);
        }
        wasOpen = open;
      };
      update();
      if (hasMO) new window.MutationObserver(update).observe(target, { attributes: true, attributeFilter: ['hidden'] });
    });
  }

  /* Erreur renvoyée par Shopify : focus sur le message (lu par les lecteurs d'écran). */
  function initAutofocus(scope, fresh) {
    if (fresh) return;
    var box = one('[data-whac-autofocus]', scope);
    if (!box || box.__whacFocused) return;
    box.__whacFocused = true;
    try { box.focus({ preventScroll: false }); } catch (e) { box.focus(); }
  }

  /* Popup « Créez votre compte et tournez la roue » de wise.js : inutile sur les pages de compte.
     wise.js l'ouvre après 5 s ; on la referme par son propre bouton juste après son apparition. */
  function tamePopup() {
    var pop = doc.getElementById('pop');
    if (!pop || pop.__whacTamed) return;
    pop.__whacTamed = true;
    lsSet('wise_welcome_popup_seen', '1');
    var previous = null;
    function closeSoon() {
      previous = doc.activeElement;
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          if (pop.hidden) return;
          var btn = pop.querySelector('[data-pop-close]');
          if (btn) btn.click();
          if (previous && previous !== doc.body && doc.contains(previous)) focusEl(previous);
        });
      });
    }
    if (!pop.hidden) {
      closeSoon();
      return;
    }
    if (!hasMO) return;
    var observer = new window.MutationObserver(function () {
      if (pop.hidden) return;
      observer.disconnect();
      closeSoon();
    });
    observer.observe(pop, { attributes: true, attributeFilter: ['hidden'] });
  }

  /* ---------- Initialisation ---------- */
  function init(scope, fresh) {
    var base = scope && scope.nodeType ? scope : doc;
    within(base, '[data-whac-dash]').forEach(function (root) { safe(initDash, root, fresh); });
    within(base, '[data-whac-portal]').forEach(function (root) { safe(initPortal, root); });
    safe(initShare, base);
    safe(initForms, base);
    safe(initCaps, base);
    safe(initAuthPanes, base);
    safe(initDisclosures, base);
    safe(initAutofocus, base, fresh);
    if (one(ROOTS)) safe(tamePopup);
  }

  window.WHAC = { version: '1.0.0', init: init };

  if (window.WH && typeof window.WH.ready === 'function') {
    window.WH.ready(function (scope) { init(scope, scope !== doc); });
    if (typeof window.WH.unload === 'function') window.WH.unload(cleanupIn);
  } else {
    var boot = function () { init(doc, false); };
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot);
    else boot();
    doc.addEventListener('shopify:section:load', function (e) { init(e.target, true); });
    doc.addEventListener('shopify:section:unload', function (e) { if (e.target) cleanupIn(e.target); });
  }

  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    all('form').forEach(function (form) { form.__whacSent = false; });
    all('[aria-busy="true"]').forEach(function (el) { el.removeAttribute('aria-busy'); });
  });
})();
